import style from "./style.module.css"
import BaseApi from "../../../services/Api";

import { useState, useEffect } from "react";
import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default function AdoptedAnimals(props) {
    const [cardsQty, setCardsQty] = useState(3);



    const handleResize = () => {
        setCardsQty(window.innerWidth <= 1200 ? (window.innerWidth<=900 ? 1 : 2) : 3);
    }

    window.addEventListener("resize", handleResize);



    useEffect(() => {
        handleResize();

    }, []);


    return (
        <>


                    <div className={style.container}>
                        <h1 className={style.adoptedTitle}>ANIMAIS JÁ ADOTADOS</h1>
                        <div className={style.slider}>
                            <div className={style.sliderNavigation}>
                                <Swiper
                                    slidesPerView={props.animal.length<cardsQty ? props.animal.length : cardsQty}
                                    pagination={{
                                        clickable: true,
                                    }}

                                    navigation = {true}
                                    className={style.swiperEdit}
                                >

                                    {props.animal.map((item)=>
                                        (
                                            <SwiperSlide key={item.id} className={style.slideSwiper} style={props.animal.length<=3 ? {margin:"auto 2px"} : {margin: "auto"}}>
                                              <div className={style.adoptedContainer}>
                                                  <img src={item.family_image ? item.family_image : item.animal_img} alt="Slider" className={style.slide_item} />
                                                  <div className={style.adoptedName}>
                                                      <h1 className={style.adoptedName}>{item.name}</h1>
                                                  </div>
                                              </div>
                                            </SwiperSlide> 
                                        )
                                    )}
                                </Swiper>
                            </div>
                        </div>
                    </div>
            </>

    )
}